(() => {
  const dialog = document.querySelector('#BirdFlockQuiz');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const storageKey = 'bird-habit-flock-quiz-seen';
  const cooldown = Number(dialog.dataset.cooldownDays || 30) * 86400000;
  const delay = Number(dialog.dataset.delay || 12000);
  const segmentStep = dialog.querySelector('[data-bird-quiz-step="segment"]');
  const emailStep = dialog.querySelector('[data-bird-quiz-step="email"]');
  const email = dialog.querySelector('#BirdFlockQuizEmail');
  const tags = dialog.querySelector('[data-bird-quiz-tags]');
  const selection = dialog.querySelector('[data-bird-quiz-selection]');
  const form = dialog.querySelector('form');
  let opened = false;

  const remember = () => {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (_error) {}
  };

  const recentlySeen = () => {
    try {
      const seenAt = Number(window.localStorage.getItem(storageKey) || 0);
      return seenAt > 0 && Date.now() - seenAt < cooldown;
    } catch (_error) {
      return false;
    }
  };

  const close = () => {
    remember();
    if (dialog.open) dialog.close();
  };

  const open = () => {
    if (opened || dialog.open || recentlySeen() || (window.Shopify && window.Shopify.designMode)) return;
    opened = true;
    dialog.showModal();
  };

  dialog.querySelectorAll('[data-bird-quiz-close]').forEach((button) => button.addEventListener('click', close));
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.querySelectorAll('[data-bird-segment]').forEach((button) => {
    button.addEventListener('click', () => {
      const value = button.dataset.birdSegment;
      const label = button.textContent.trim();
      tags.value = `newsletter,bird-habit-quiz,segment-${value}`;
      selection.textContent = `${label}. Good choice.`;
      segmentStep.hidden = true;
      emailStep.hidden = false;
      email.focus();
    });
  });

  dialog.querySelector('[data-bird-quiz-back]')?.addEventListener('click', () => {
    emailStep.hidden = true;
    segmentStep.hidden = false;
    dialog.querySelector('[data-bird-segment]')?.focus();
  });

  form?.addEventListener('submit', remember);

  if (dialog.querySelector('[data-bird-quiz-success]') || dialog.querySelector('.bird-flock-quiz__error')) {
    dialog.showModal();
    dialog.querySelector('[data-bird-quiz-success], .bird-flock-quiz__error')?.focus();
    return;
  }

  if (!recentlySeen()) {
    window.setTimeout(open, delay);
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.35) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
